import { Routes, Route, Navigate } from "react-router-dom";
import ReviewForm from "./pages/ReviewForm";
import NotFound from "./pages/NotFound";

export default function PublicRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin/login" replace />} />
      {/* Single page review form - accessed via QR code - uses product slug */}
      <Route path="/review/:slug" element={<ReviewForm />} />
      {/* Legacy routes for backward compatibility */}
      <Route path="/product/:slug" element={<ReviewForm />} />
      
      {/* Catch-all route for unknown paths */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
